import { LOGOUT } from "@apiUtils";
import { mutationFetch } from "@atlas/sdk";
import { type UseMutationOptions, useMutation } from "@tanstack/react-query";
import type { AxiosError } from "axios";

const logout = (): Promise<void> => {
  return mutationFetch<void>({
    url: LOGOUT,
    method: "POST",
    responseType: "text",
  });
};

export const useLogout = (
  options?: UseMutationOptions<void, AxiosError, void>,
) => {
  return useMutation({
    mutationFn: logout,
    ...options,
  });
};
